<template>
  <v-data-table
    :headers="headers"
    :items="securities"
    :rows-per-page-items="rowsPerPageItems"
    :pagination.sync="pagination"
    class="elevation-1"
    @update:pagination="updatePagination"
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr @click="_toggleWUM(props.item.id)">
        <td
          v-for="(header, index) in headers"
          :key="index"
          class="text-xs"
        >
          <div v-if="header.value === 'XXX-SALDO'">
            {{ props.item[header.value] | currency('€') }}
          </div>

          <div v-else>
            {{ props.item[header.value] }}
          </div>
        </td>
      </tr>

      <!-- Security menu start -->
      <tr
        v-if="statuses[props.item.id]['menuExpanded']"
        @click="_detailSecurityTransactions(props.item.id, props.item['XXX-WPNR'])"
      >
        <td colspan="100%">
          <div class="expanded-wrapper">
            {{ 'Security transactions' }}
          </div>
        </td>
      </tr>
      <!-- Security menu end -->

      <!-- Security transactions start -->
      <tr
        v-show="statuses[props.item.id]['securityTransactionsExpanded']"
        class="expand"
      >
        <td colspan="100%">
          <v-expansion-panel>
            <v-expansion-panel-content
              v-model="statuses[props.item.id]['securityTransactionsExpanded']"
            >
              <v-card>
                <v-card-text class="grey lighten-3">
                  <div
                    v-if="statuses[props.item.id]['securityLoad']"
                    class="transactions-wrapper"
                  >
                    <security-transactions
                      v-if="statuses[props.item.id]['securityTransactions'].length > 0"
                      :transactions="statuses[props.item.id]['securityTransactions']"
                    />
                    <v-alert
                      v-else
                      :value="true"
                      type="error"
                      color="error"
                    >
                      {{ 'No security transaction' }}
                    </v-alert>
                  </div>
                  <div
                    v-else
                    class="load-wrapper"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
      </tr>
      <!-- Security transactions end -->

      <!-- Payment menu start -->
      <tr
        v-if="statuses[props.item.id]['menuExpanded']"
        @click="_detailPaymentTransactions(props.item.id, props.item['XXX-WPNR'])"
      >
        <td colspan="100%">
          <div class="expanded-wrapper">
            {{ 'Payment transactions' }}
          </div>
        </td>
      </tr>
      <!-- Payment menu end -->

      <!-- Payment transactions start -->
      <tr
        v-show="statuses[props.item.id]['paymentTransactionsExpanded']"
        class="expand"
      >
        <td colspan="100%">
          <v-expansion-panel>
            <v-expansion-panel-content
              v-model="statuses[props.item.id]['paymentTransactionsExpanded']"
            >
              <v-card>
                <v-card-text class="grey lighten-3">
                  <div
                    v-if="statuses[props.item.id]['paymentLoad']"
                    class="transactions-wrapper"
                  >
                    <payment-transactions
                      v-if="statuses[props.item.id]['paymentTransactions'].length > 0"
                      :transactions="statuses[props.item.id]['paymentTransactions']"
                    />
                    <v-alert
                      v-else
                      :value="true"
                      type="error"
                      color="error"
                    >
                      {{ 'No security transaction' }}
                    </v-alert>
                  </div>
                  <div
                    v-else
                    class="load-wrapper"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
      </tr>
      <!-- Security transactions end -->
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex';
import SecurityTransactions from './SecurityTransactions.vue';
import PaymentTransactions from './PaymentTransactions.vue';
import { setQuery } from '@/helpers';

export default {
  name: 'WUMTransactionsComponent',
  components: {
    SecurityTransactions,
    PaymentTransactions,
  },
  props: {
    securities: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: this.securities.length,
      },
      rowsPerPageItems: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: 'All', value: -1 },
      ],
      headers: [
        {
          text: 'XXX-WPBEZ1',
          value: 'XXX-WPBEZ1',
        },
        {
          text: 'XXX-WPNR',
          value: 'XXX-WPNR',
        },
        {
          text: 'XXX-NW-M',
          value: 'XXX-NW-M',
        },
        {
          text: 'XXX-SALDO',
          value: 'XXX-SALDO',
        },
      ],
      statuses: {},
      isLoadTableData: false,
    };
  },
  watch: {
    pagination: {
      handler() {
        this.isLoadTableData = true;
      },
    },
  },
  async mounted() {
    await this.$nextTick();
    this.changePage();
  },
  created() {
    this.securities.forEach((i) => {
      this.$set(this.statuses, i.id, {
        menuExpanded: false,
        securityTransactionsExpanded: false,
        securityTransactions: [],
        securityLoad: false,
        paymentTransactionsExpanded: false,
        paymentLoad: false,
        paymentTransactions: [],
      });
    });
  },

  methods: {
    ...mapActions([
      'getSecurityTransactionsOfWUM',
      'getPaymentTransactionsOfWKN',
    ]),
    _toggleWUM(id) {
      this.statuses[id].menuExpanded = !this.statuses[id].menuExpanded;
      this.statuses[id].securityLoad = false;
      this.statuses[id].paymentLoad = false;
      this.statuses[id].securityTransactionsExpanded = false;
      this.statuses[id].paymentTransactionsExpanded = false;
      this.statuses[id].securityTransactions = [];
      this.statuses[id].paymentTransactions = [];
    },
    async _detailSecurityTransactions(id, wpnr) {
      const oposite = !this.statuses[id].securityTransactionsExpanded;
      this.statuses[id].securityTransactionsExpanded = oposite;
      const payload = {
        snr: this.$route.params.snr,
        wkn: wpnr,
      };

      if (this.statuses[id].securityTransactionsExpanded) {
        this.statuses[id].securityLoad = false;
        this.statuses[id].securityTransactions = await this.getSecurityTransactionsOfWUM(payload)
          .then((transactions) => {
            this.statuses[id].securityLoad = true;

            return transactions;
          })
          .catch(() => {
            this.statuses[id].securityLoad = true;

            return [];
          });
      }
    },
    async _detailPaymentTransactions(id, wpnr) {
      const oposite = !this.statuses[id].paymentTransactionsExpanded;
      this.statuses[id].paymentTransactionsExpanded = oposite;
      const payload = {
        snr: this.$route.params.snr,
        wkn: wpnr,
      };

      if (this.statuses[id].paymentTransactionsExpanded) {
        this.statuses[id].paymentLoad = false;
        this.statuses[id].paymentTransactions = await this.getPaymentTransactionsOfWKN(payload)
          .then((transactions) => {
            this.statuses[id].paymentLoad = true;

            return transactions;
          })
          .catch(() => {
            this.statuses[id].paymentLoad = true;

            return [];
          });
      }
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery({ wumPage: pagination.page }, this.$route, this.$router);
      }
    },
    changePage() {
      const { wumPage } = this.$route.query;
      this.pagination.page = wumPage ? Number(wumPage) : 1;
    },
  },
};
</script>
<style lang='scss' scoped>
tr.expand td {
  padding: 0 !important;
}

tr.expand .expansion-panel {
  box-shadow: none;
}

tr.expand .expansion-panel li {
  border: none;
}

.load-wrapper {
  display: flex;
  justify-content: center;
}

.transactions-wrapper {
  max-height: 300px;
  overflow-y: auto;
  margin-left: 12px;
}

.expanded-wrapper {
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/baader/WUMTransactionsComponent.vue